import { useState } from 'react'

import { BasicDialog } from '@/components/basic-dialog'
import Button from '@/components/button'
import { useCreatePulverizationMap } from '@/pages/diagnosis-view/contexts/create-pulverization-map-context'

import { SummaryTable } from '../../summary-table'
import { ExportFilesMenu } from './export-files-menu'
import { useStyles } from './styles'

export function PulverizationSummary() {
  const classes = useStyles()

  const [isNewPulverizationModalOpen, setIsNewPulverizationModalOpen] =
    useState(false)

  const {
    previousStep,
    pulverizationData,
    canRestartPulverization,
    restartPulverization,
  } = useCreatePulverizationMap()

  function handleNewPersonalization() {
    restartPulverization()
  }

  return (
    <>
      <SummaryTable summary={pulverizationData?.summary} withInfoGroup />

      <div className={classes.buttonContainer}>
        {canRestartPulverization ? (
          <Button outlined onClick={previousStep}>
            Voltar
          </Button>
        ) : (
          <Button outlined onClick={() => setIsNewPulverizationModalOpen(true)}>
            Nova personalização
          </Button>
        )}
        <ExportFilesMenu />
      </div>

      <BasicDialog
        open={isNewPulverizationModalOpen}
        title='Criar novo mapa'
        cancelMessage='cancelar'
        confirmMessage='Criar novo mapa'
        onConfirm={handleNewPersonalization}
        onClose={() => setIsNewPulverizationModalOpen(false)}
      >
        Se você der continuidade a esta ação, os dados gerados na ultima
        personalização serão descartados.
      </BasicDialog>
    </>
  )
}
